/**
 * 帳票管理ページ用のスクリプト
 */
if (is_route('sheet.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function () {
        sheet_event_set();
    });
}

/**
 * ページ読み込み時のイベント設定
 */
window.sheet_event_set = function () {

    $(function () {
        if($('.group-button.active').data('group') == 'driver'){
            $('#form-vehicle').prop('hidden',true);
        }else{
            $('#form-driver').prop('hidden',true);
        }
    });

    /*---- 検索条件変更時 ----*/
    // 入力日時（開始）変更時
    $(document).on('change', '#search-form-end_time_from', function () {
        let last_day = null;
        selected_date = $(this).val();
        set_end = $('#search-form-end_time_to').val();
        if (set_end != '') {
            selected_date = new Date(selected_date);
            chk_date_over = new Date(selected_date.getFullYear(), selected_date.getMonth(), selected_date.getDate() + 31);
            chk_date = new Date(selected_date.getFullYear(), selected_date.getMonth(), selected_date.getDate());
            set_end = new Date(set_end);
            yyyymmdd = new Date(set_end.getFullYear(), set_end.getMonth(), set_end.getDate());
            if (chk_date_over.getTime() < yyyymmdd.getTime()) {
                yyyymmdd = new Date(selected_date.getFullYear(), selected_date.getMonth(), selected_date.getDate() + 31);
                last_day = yyyymmdd.getFullYear() + '/' +
                    ("0" + (yyyymmdd.getMonth() + 1)).slice(-2) + '/' +
                    ("0" + yyyymmdd.getDate()).slice(-2);
                $('#search-form-end_time_to').val(last_day);
            } else if (chk_date.getTime() > yyyymmdd.getTime()) {
                last_day = chk_date.getFullYear() + '/' +
                    ("0" + (chk_date.getMonth() + 1)).slice(-2) + '/' +
                    ("0" + chk_date.getDate()).slice(-2);
                $('#search-form-end_time_to').val(last_day);
            }
        }
    });

    // 入力日時（終了）変更時
    $(document).on('change', '#search-form-end_time_to', function () {
        let last_day = null;
        selected_date = $(this).val();
        set_start = $('#search-form-end_time_from').val();
        if (set_start != '') {
            selected_date = new Date(selected_date);
            set_start = new Date(set_start);
            yyyymmdd = new Date(set_start.getFullYear(), set_start.getMonth(), set_start.getDate() + 31);
            yyyymmdd_2 = new Date(set_start.getFullYear(), set_start.getMonth(), set_start.getDate());
            if (selected_date.getTime() > yyyymmdd.getTime()) {
                last_day = yyyymmdd.getFullYear() + '/' +
                    ("0" + (yyyymmdd.getMonth() + 1)).slice(-2) + '/' +
                    ("0" + yyyymmdd.getDate()).slice(-2);
                $('#search-form-end_time_to').val(last_day);
            } else if (selected_date.getTime() < yyyymmdd_2.getTime()) {
                last_day = yyyymmdd_2.getFullYear() + '/' +
                    ("0" + (yyyymmdd_2.getMonth() + 1)).slice(-2) + '/' +
                    ("0" + yyyymmdd_2.getDate()).slice(-2);
                $('#search-form-end_time_to').val(last_day);
            }
        }
    });

    /*---- 車両選択時 ----*/
    $(document).on('change', 'select[name="vehicle_ids[]"]', function ()
    {
        // PCKK選択時、車両未選択の時はデータ出力ボタンは押下できない
        let category = $('.category-button.active').data('category');
        if (category === 'pckk') {
            if ($(this).find('option:selected').length > 0) {
                $('#sheet_pckk_download_button').removeClass('btn-default').addClass('btn-success').prop('disabled', false);
            } else {
                $('#sheet_pckk_download_button').removeClass('btn-success').addClass('btn-default').prop('disabled', true);
            }
        }
    });

    // /*---- CSVダウンロード時 ----*/

    // // CSVダウンロード時
    // $(document).on('click', '#search-form-action_download', function () {
    //     // アクションの取得
    //     let action = extend_url_query($(this).data('action'));
    //     // 検索フォームを配列化
    //     let data = $('#search-form').serializeArray();
    //     // ポスト送信を実行
    //     post(action, data);
    // });

    /*---- 日報出力ボタン押下時 ----*/
    // 日報出力ボタン押下時
    $(document).on('click', '#sheet_printingreport_button', function () {
        const action = $(this).data('action'); // 例: /sheet/printingreport
        const validateUrl = action.replace(/\/printingreport$/, '/printingreport/validate'); // 例
        const group = $('.group-button.active').data('group');
        const vals = $('select[name="'+group+'_ids[]"]').val() || []; // => ["1","3",...]
        const sectionId = $('#section_id').val();

        const data = [
            { name: 'holding_id', value: $('#holding_id').val() },
            { name: 'company_id', value: $('#company_id').val() },
            { name: 'section_id', value: $('#section_id').val() },
            { name: 'end_time_from', value: $('#search-form-end_time_from').val() },
            { name: 'end_time_to', value: $('#search-form-end_time_to').val() },
            { name: 'category', value: $('.category-button.active').data('category') },
            { name: 'group', value: $('.group-button.active').data('group') },
            { name: 'type', value: $('.type-button.active').data('type') },
            { name: 'summary', value: $('.summary-button.active').data('summary') },
            { name: 'sort', value: $('.sort-button.active').data('sort') },
            { name: 'add_non_driver', value: $('.add_non_driver-button.active').data('add_non_driver') },
            { name: 'driver_ids', value:$('select[name="driver_ids[]"]').val() || [] },
            { name: 'vehicle_ids', value:$('select[name="vehicle_ids[]"]').val() || [] },

        ];

        _error.reset();

        _ajax.post(validateUrl, data, function (results) {
            console.log('[validate] OK', results);
            // ← ここでは PDF を返さない
            _ajax.blob(action, data, function (blob) {
                console.log('[blob] OK size:', blob.size);
                window.open(URL.createObjectURL(blob), '_blank');
            }, function (xhr, status, err) {
                console.error('[blob] NG', status, err);
                _error.omitted(xhr, status, err);
            });

        }, function (xhr, status, err) {
            console.error('[validate] NG', status, err);
            _error.set('#search-form', xhr, status, err, true);
        });
    });

    /*---------------------------------------
     作業実績集計データ出力ボタン押下
     グループ会社・車両のみ選択時はdisabledとする
    ----------------------------------------*/

    $(document).on('click', '#sheet_pckk_download_button', function () {
        const action = $(this).data('action');
        const data = [
            { name: '_token', value: $('form').find('input[name="_token"]').val() },
            { name: 'holding_id', value: $('#holding_id').val() },
            { name: 'company_id', value: $('#company_id').val() },
            { name: 'end_time_from', value: $('#search-form-end_time_from').val() },
            { name: 'end_time_to', value: $('#search-form-end_time_to').val() },
            { name: 'category', value: $('.category-button.active').data('category') },
            { name: 'group', value: $('.group-button.active').data('group') },
            { name: 'vehicle_ids', value:$('select[name="vehicle_ids[]"]').val() || [] },
            { name: 'check', value:true },
        ];

        // 存在チェックしてからCSVダウンロードする
        _ajax.post(action, data, function (results) {
            // checkパラメタ排除
            const param = data.filter(item => item.name !== 'check');
            post(action, param);
        }, function (xhr, status, err) {
            _error.set('#search-form', xhr, status, err, true);
        });
    });

    $(document).on('click', '.group-button', function () {
        let group = $(this).data('group');
        let category = $('.category-button.active').data('category');
        renderTypes(category, group);
        let isHidden = true;
        if (group === 'driver') {
            isHidden = false;
        }
        $('#form-add-non-driver').prop('hidden', isHidden);
        renderTargets(group);
    });

    $(document).on('click', '.category-button', function () {
        let category = $(this).data('category');
        let group = $('.group-button.active').data('group');
        if (group == 'vehicle' && category == 'evaluation') {
            group = 'driver';
        }
        if (category == 'pckk') {
            group = 'vehicle';
        }

        // カテゴリごとの選択要素の非表示制御
        if (category == 'evaluation') {
            $('#form-add-non-driver').prop('hidden', false);
        } else if (category === 'pckk') {
            // pckk選択時は、運転者/車両以外の要素は非表示で、選択できるのは車両のみ
            $('#row-type').prop('hidden', true);
            $('#row-summary-sort').prop('hidden', true);
            $('#form-add-non-driver').prop('hidden', true);
            $('#sheet_printingreport_button').prop('hidden', true);
            $('#sheet_pckk_download_button').prop('hidden', false);
        } else {
            $('#tab-sheet-summary-detail').prop('hidden', false);
            if (group === 'driver') {
                $('#form-add-non-driver').prop('hidden', false);
            }
        }
        // カテゴリ・運転者/車両別の選択要素の生成
        renderGroups(category, group);
        if (category !== 'pckk') {
            $('#row-type').prop('hidden', false);
            $('#row-summary-sort').prop('hidden', false);
            $('#sheet_printingreport_button').prop('hidden', false);
            $('#sheet_pckk_download_button').prop('hidden', true);
            renderTypes(category, group);
            renderSort();
        }
    });

    $(document).on('click', '.type-button', function () {
        let type = $(this).data('type');
        if (type == 'safety' || type == 'economic' || type == 'total') {
            $('#tab-sheet-summary-detail').prop('hidden', true);
        }else {
            $('#tab-sheet-summary-detail').prop('hidden', false);
        }
    });

    // 画面表示
    $(document).on('click', '[data-sheet-select]', function () {
        _modal.create(this, 'sheet-select', [], true, function () {
            initialize('tree-multiselect');
        });
    });

    // 帳票区分
    function renderTypes(category, group) {
        const container = $('#type-button-tab');
        container.empty(); // 中身を一度クリア
        // データ組み立て
        const configSheetsList = JSON.parse($('#config-sheets-data').attr('data-config-sheets-list'));
        const categories = configSheetsList[category];
        const $localizeSheet = $('#localize-sheet-data');
        const localizeSheets = $localizeSheet.data('localize');
        const type = $('.type-button.active').data('type');
        let isInit = true;

        // タグを作成
        Object.entries(categories[group]).forEach(([key, value], index) => {
            const tabId = 'tab-sheet-type-' + key;
            const listId = 'list-sheet-type-' + key;
            let isSelectedTab = (type !== null) ? type == key : null;
            if (isInit) {
                isSelectedTab = true;
                isInit = false;
            }
            const $a = $('<a>', {
                class: 'type-button nav-link font-weight-bold btn m-1 p-1' + (isSelectedTab ? ' active' : ''),
                id: tabId,
                'data-type': key,
                'data-toggle': 'pill',
                href: '#' + listId,
                role: 'tab',
                'aria-controls': listId,
                'aria-selected': isSelectedTab ? 'true' : 'false'
            }).text(localizeSheets['type'][key]);
            container.append($a);
        });
    }

    // 運転者/車両
    function renderGroups(category, group) {
        const container = $('#group-button-tab');
        container.empty(); // 中身を一度クリア
        const configSheetsList = JSON.parse($('#config-sheets-data').attr('data-config-sheets-list'));
        const $localizeSheet = $('#localize-sheet-data');
        const localizeSheets = $localizeSheet.data('localize');

        // タグを作成
        Object.entries(configSheetsList[category]).forEach(([key, value], index) => {
            const tabId = 'tab-sheet-group-' + key;
            const listId = 'list-sheet-group-' + key;
            const isSelectedTab = (group !== null) ? group == key : null;

            const $a = $('<a>', {
                class: 'group-button nav-link font-weight-bold btn m-1 p-1' + (isSelectedTab === true ? ' active' : ''),
                id: tabId,
                'data-group': key,
                'data-toggle': 'pill',
                href: '#' + listId,
                role: 'tab',
                'aria-controls': listId,
                'aria-selected': 'false',
            }).text(localizeSheets['group'][key]);
            container.append($a);
        });
        // 表示する運転者・車両の表示を更新
        renderTargets(group);

    }


    // 並び順
    function renderSort() {
        let container = $('#sort-button-tab');
        container.empty();

        const category = $('.category-button.active').data('category');
        const group = $('.group-button.active').data('group');
        const type = $('.type-button.active').data('type');
        const summary = $('.summary-button.active').data('summary');
        const configSheetsList = JSON.parse($('#config-sheets-data').attr('data-config-sheets-list'));


        if (Array.isArray(configSheetsList[category][group][type][summary])) {
            // labelは削除しなくてもよいので非表示にする
            $('#form-sort').prop('hidden', true);
            return;
        }

        let formSort = $('#form-sort');
        // 並びの順のlabelがないときもあるためなlabelの作成を行う
        if (!formSort.length) {
            const localizeFormSheets = $('#localize-form-sheet-data').data('localize_sheet');
            const $formSort = $('<div>', { class: 'form-sort col-4', id: 'form-sort' })
                .append($('<label>', { class: 'label', text: localizeFormSheets['list']['sort']['label'] }))
                .append($('<div>', { class: 'tab-list nav nav-tabs', role: 'tablist', id: 'sort-button-tab' }));
            $('#row-summary-sort .form-group').first().after($formSort);
            container = $('#sort-button-tab');
        }

        // タグ作成
        const sort = $('.sort-button.active').data('sort');
        $('#form-sort').prop('hidden', false);
        const localizeSheets = $('#localize-sheet-data').data('localize');
        let isInit = true;
        Object.entries(configSheetsList[category][group][type][summary]).forEach(([key, value], index) => {
            const tabId = 'tab-sheet-sort-' + key;
            const listId = 'list-sheet-sort-' + key;
            let isSelectedTab = (sort !== null) ? sort == key : null;
            if (isInit) {
                isSelectedTab = true;
                isInit = false;
            }
            const $a = $('<a>', {
                class: 'sort-button nav-link font-weight-bold btn m-1 p-1' + (isSelectedTab === true ? ' active' : ''),
                id: tabId,
                'data-sort': key,
                'data-toggle': 'pill',
                href: '#' + listId,
                role: 'tab',
                'aria-controls': listId,
                'aria-selected': 'false',
            }).text(localizeSheets['sort'][key]);
            container.append($a);
        });
    }

    function renderTargets(group) {
        $(".tree-multiselect .unselect-all").click();// 選択解除
        if(group == 'driver'){
            $('#form-vehicle').prop('hidden',true);
            $('#form-driver').prop('hidden',false);
        }else{
            $('#form-driver').prop('hidden',true);
            $('#form-vehicle').prop('hidden',false);
        }

    }
}
